import { useEffect, FC } from 'react';
import Router from 'next/router';
import { useDispatch } from 'react-redux';
import { OrderActions } from '@lib/state/_actions';
import container from '@lib/container';
import {
    CURRENT_ORDER_ID_STORAGE,
    ORDER_TRACKING_CONVERSION_STORAGE,
} from '@lib/constants/ORDER';

import APP_CONFIG from '@lib/constants/APP_CONFIG';

const ConversionTracking: FC = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        const orderID = localStorage.getItem(CURRENT_ORDER_ID_STORAGE);
        console.log({ orderID });
        
        if (orderID) {
            console.log(1, { orderID });
            
            (async (): Promise<void> => {
                try {
                    const { data } =
                        await container.cradle.orderRepository.getListOrder({
                            order_summary_ids: [orderID],
                            page_index: 1,
                            page_size: 1,
                        });
                    console.log({ data });
                    
                    if (
                        data.length &&
                        data[0] &&
                        data[0].summary.payment_status === 'paid'
                    ) {
                        dispatch(
                            OrderActions.addOrderIdNotLoggedIn(
                                data[0].summary.id,
                            ),
                        );
                        dispatch(OrderActions.setIsNewOrder(true));
                        localStorage.removeItem(CURRENT_ORDER_ID_STORAGE);
                        const dataLayer = {
                            event: APP_CONFIG.EVENT_CONCONVERSION,
                            currency_code: 'USD',
                            transaction_id: data[0].summary.id,
                            conversion_value: data[0].summary.total,
                            email_enhance: data[0].summary.payer_email_address,
                        };
                        const dataLayerGA = {
                            event: 'purchase',
                            ga_category: APP_CONFIG.GA_CATEGORY,
                            ga_action: 'purchase',
                            ga_label: 'Purchase',
                            ga_value: Number(data[0].summary.total),
                        };
                        if (Router.pathname !== '/dashboard') {
                            localStorage.setItem(
                                ORDER_TRACKING_CONVERSION_STORAGE,
                                JSON.stringify(dataLayer),
                            );
                            Router.push('/dashboard');
                        } else {
                            console.log('dataLayer',window.dataLayer);
                            
                            window.dataLayer.push(dataLayer);
                            window.dataLayer.push(dataLayerGA);
                            localStorage.removeItem(
                                ORDER_TRACKING_CONVERSION_STORAGE,
                            );
                        }
                    }
                } catch (error) {
                    // eslint-disable-next-line
                    console.log('Get order error', error);
                    localStorage.removeItem(CURRENT_ORDER_ID_STORAGE);
                }
            })();
        }
    }, [dispatch]);
    return null;
};

export default ConversionTracking;
